import { Link } from 'react-router-dom';
import { FiInstagram, FiFacebook, FiTwitter, FiLinkedin, FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import { useSettings } from '../context/SettingsContext';

export default function Footer() {
  const { settings } = useSettings();
  const s = settings || {};
  const socials = [
    { icon: <FiInstagram />, url: s.instagram },
    { icon: <FiFacebook />, url: s.facebook },
    { icon: <FiTwitter />, url: s.twitter },
    { icon: <FiLinkedin />, url: s.linkedin },
  ].filter((x) => x.url);

  return (
    <footer className="footer">
      <div className="container footer__grid">
        <div>
          <Link to="/" className="footer__brand">
            <img src={s.logo || '/logo.png'} alt={s.siteName} />
            <span>{s.siteName || 'Kortex'}</span>
          </Link>
          <p className="muted" style={{ marginTop: 14, maxWidth: 320 }}>
            {s.tagline || 'Design. Build. Deliver.'}
          </p>
          {socials.length > 0 && (
            <div className="footer__socials">
              {socials.map((soc, i) => (
                <a key={i} href={soc.url} target="_blank" rel="noreferrer" className="footer__soc">
                  {soc.icon}
                </a>
              ))}
            </div>
          )}
        </div>

        <div>
          <h4 className="footer__title">Explore</h4>
          <Link to="/products" className="footer__link">Products</Link>
          <Link to="/services" className="footer__link">Services</Link>
          <Link to="/about" className="footer__link">About Us</Link>
          <Link to="/contact" className="footer__link">Contact</Link>
        </div>

        <div>
          <h4 className="footer__title">Get in touch</h4>
          {s.email && <a href={`mailto:${s.email}`} className="footer__link"><FiMail /> {s.email}</a>}
          {s.phone && <a href={`tel:${s.phone}`} className="footer__link"><FiPhone /> {s.phone}</a>}
          {s.address && <span className="footer__link"><FiMapPin /> {s.address}</span>}
        </div>
      </div>
      <div className="footer__bottom container">
        <span>© {new Date().getFullYear()} {s.siteName || 'Kortex'}. All rights reserved.</span>
      </div>
    </footer>
  );
}
